import "./jquery-global";
import jQuery from "jquery";
import slate from "./vendor/slate";
import "slick-carousel";
import "@fancyapps/fancybox";
import "~/styles/vendor/jquery.fancybox.min.scss";
import "jquery-zoom";
import { getCookie, setCookie } from "../utils/utils";
import { updateProductFavouritesIcon } from "./favourites";

const $ = jQuery;

/* eslint-disable no-useless-return */
/* eslint-disable camelcase */
/* eslint-disable max-len */
/* eslint-disable no-plusplus */
/* eslint-disable eqeqeq */
/* eslint-disable func-names */
/* eslint-disable object-shorthand */
/* eslint-disable no-unused-vars */
/* eslint-disable no-undef */
/**
 * Product Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Product template.
 *
 * @namespace product
 */

theme.Product = (() => {
    const selectors = {
        productForm: "[data-cart-submit]",
        addToCart: "[data-add-to-cart]",
        addToCartText: "[data-add-to-cart-text]",
        comparePrice: "[data-compare-price]",
        comparePriceText: "[data-compare-text]",
        originalSelectorId: "[data-product-select]",
        priceWrapper: "[data-price-wrapper]",
        productFeaturedImage: "[data-product-featured-image]",
        productJson: "[data-product-json]",
        productPrice: "[data-product-price]",
        productThumbs: "[data-product-single-thumbnail]",
        singleOptionSelector: "[data-single-option-selector]",
    };

    /**
     * Product section constructor. Runs on page load as well as Theme Editor
     * `section:load` events.
     * @param {string} container - selector for the section container DOM element
     */
    function Product(container) {
        this.$container = $(container);

        // Stop parsing if we don't have the product json script tag when loading
        // section in the Theme Editor
        if (!$(selectors.productJson, this.$container).html()) {
            return;
        }

        const sectionId = this.$container.attr("data-section-id");
        this.productSingleObject = JSON.parse(
            $(selectors.productJson, this.$container).html(),
        );

        const options = {
            $container: this.$container,
            enableHistoryState:
                this.$container.data("enable-history-state") || false,
            singleOptionSelector: selectors.singleOptionSelector,
            originalSelectorId: selectors.originalSelectorId,
            product: this.productSingleObject,
        };

        this.settings = {};
        this.namespace = ".product";
        this.variants = new slate.Variants(options);
        this.$featuredImage = $(
            selectors.productFeaturedImage,
            this.$container,
        );

        this.$container.on(
            `variantChange${this.namespace}`,
            this.updateAddToCartState.bind(this),
        );
        this.$container.on(
            `variantPriceChange${this.namespace}`,
            this.updateProductPrices.bind(this),
        );

        if (this.$featuredImage.length > 0) {
            this.settings.imageSize = slate.Image.imageSize(
                this.$featuredImage.attr("src"),
            );
            slate.Image.preload(
                this.productSingleObject.images,
                this.settings.imageSize,
            );

            this.$container.on(
                `variantImageChange${this.namespace}`,
                this.updateProductImage.bind(this),
            );
        }
    }

    Product.prototype = $.extend({}, Product.prototype, {
        /**
         * Updates the DOM state of the add to cart button
         *
         * @param {boolean} enabled - Decides whether cart is enabled or disabled
         * @param {string} text - Updates the text notification content of the cart
         */
        updateAddToCartState: function (evt) {
            const { variant } = evt;
            let variantQty = 0;

            if (variant) {
                $(selectors.priceWrapper, this.$container).removeClass("hide");
            } else {
                $(selectors.addToCart, this.$container).prop("disabled", true);
                $(selectors.addToCartText, this.$container).html(
                    theme.strings.unavailable,
                );
                $(selectors.priceWrapper, this.$container).addClass("hide");
                return;
            }

            if (variant.available) {
                $(selectors.addToCart, this.$container).prop("disabled", false);
                $(selectors.addToCartText, this.$container).html(
                    theme.strings.addToCart,
                );

                if (
                    $(selectors.productForm, this.$container).hasClass(
                        "back-in-stock",
                    )
                ) {
                    $(selectors.productForm, this.$container).removeClass(
                        "back-in-stock",
                    );
                }

                if (
                    $(selectors.addToCart, this.$container).hasClass("hideThis")
                ) {
                    $(selectors.addToCart, this.$container).removeClass(
                        "hideThis",
                    );
                }

                if (
                    $(".back-in-stock-email-container").hasClass("hideThis") ==
                    false
                ) {
                    $(".back-in-stock-email-container").addClass("hideThis");
                }

                if ($(".selector-quantity").hasClass("hideThis")) {
                    $(".selector-quantity").removeClass("hideThis");
                }

                if (
                    variantStock[variant.id] > 0 &&
                    variant.inventory_management == "shopify"
                ) {
                    variantQty = `${variantStock[variant.id]}`;
                }
            } else {
                $(selectors.addToCartText, this.$container).html(
                    theme.strings.soldOut,
                );

                if (
                    !$(selectors.productForm, this.$container).hasClass(
                        "back-in-stock",
                    )
                ) {
                    $(selectors.productForm, this.$container).addClass(
                        "back-in-stock",
                    );
                }

                if ($(".back-in-stock-email-container").hasClass("hideThis")) {
                    $(".back-in-stock-email-container").removeClass("hideThis");
                }

                if ($(".selector-quantity").hasClass("hideThis") == false) {
                    $(".selector-quantity").addClass("hideThis");
                }
            }

            const variantID = $(
                'select[data-index="option1"] option:selected',
            ).attr("data-variant-id");
            $("#product-page-favourites-container .open-modal").attr(
                "data-variant-id",
                variantID,
            );
            updateProductFavouritesIcon();

            // Change Quantity Selector Size
            const variantQuantity = variantQty;
            let quantitySelectorSize = 10;
            let newOptionForQuantity = "";

            if (variantQuantity < quantitySelectorSize) {
                quantitySelectorSize = variantQuantity;
            }

            // Override quantity when displaying a gift card
            if (
                variant.name.includes("Gift") &&
                variant.name.includes("Card")
            ) {
                quantitySelectorSize = 10;
            }

            for (let i = 1; i <= quantitySelectorSize; i++) {
                newOptionForQuantity += `<option value="${i}">${i}</option>`;
            }

            $("#productQuantity").html(newOptionForQuantity);
        },

        /**
         * Updates the DOM with specified prices
         *
         * @param {string} productPrice - The current price of the product
         * @param {string} comparePrice - The original price of the product
         */
        updateProductPrices: function (evt) {
            const { variant } = evt;
            const $comparePrice = $(selectors.comparePrice, this.$container);
            const $compareEls = $comparePrice.add(
                selectors.comparePriceText,
                this.$container,
            );
            const $productPrice = $(selectors.productPrice, this.$container);
            let saleLabel = "";

            if (variant.compare_at_price > variant.price) {
                $comparePrice.html(
                    slate.Currency.formatMoney(
                        variant.compare_at_price,
                        theme.moneyFormat,
                    ),
                );
                $compareEls.removeClass("hide");
                $productPrice.addClass("sale-price");
                saleLabel = `${theme.strings.sale} `;
            } else {
                $comparePrice.html("");
                $compareEls.addClass("hide");
                $productPrice.removeClass("sale-price");
            }

            $(selectors.productPrice, this.$container).html(
                saleLabel +
                    slate.Currency.formatMoney(
                        variant.price,
                        theme.moneyFormat,
                    ),
            );
        },

        /**
         * Updates the DOM with the specified image URL
         *
         * @param {string} src - Image src URL
         */
        updateProductImage: function (evt) {
            const { variant } = evt;
            const sizedImgUrl = slate.Image.getSizedImageUrl(
                variant.featured_image.src,
                this.settings.imageSize,
            );

            this.$featuredImage.attr("src", sizedImgUrl);
        },

        /**
         * Event callback for Theme Editor `section:unload` event
         */
        onUnload: function () {
            this.$container.off(this.namespace);
        },
    });

    return Product;
})();

// Mirrors the widths emitted by the product-image-preload snippet and
// the desktop product-media-grid <img>, using the same ?width= URL
// format so the browser reuses the LCP preload across both render
// paths instead of double-fetching.
const PRODUCT_IMAGE_SRCSET_WIDTHS = [345, 550, 750, 1100, 1445];
const PRODUCT_IMAGE_SIZES = "(min-width: 1024px) 1100px, 100vw";

function buildSizedImageUrl(src, width) {
    const [imageUrl, query] = src.split("?");
    const params = new URLSearchParams(query || "");
    params.set("width", String(width));
    return `${imageUrl}?${params.toString()}`;
}

function generateSrcsetForProductImages(src) {
    return PRODUCT_IMAGE_SRCSET_WIDTHS.map(
        (width) => `${buildSizedImageUrl(src, width)} ${width}w`,
    ).join(", ");
}

function openDrawer(el) {
    if (!el) return;
    el.classList.add("active");
    el.setAttribute("aria-hidden", "false");
}

function closeDrawer(el) {
    if (!el) return;
    el.classList.remove("active");
    el.setAttribute("aria-hidden", "true");
}

$(document).ready(() => {
    const sizeDrawer = document.querySelector(".sizeDrawer");
    const sizeCloseX = document.querySelector(".sizeCloseX");

    sizeCloseX?.addEventListener("click", () => {
        closeDrawer(sizeDrawer);
    });

    window.addEventListener("keydown", (e) => {
        if (e.key === "Escape") closeDrawer(sizeDrawer);
    });
    // Render all slideshow images
    const renderSlideshowImages = () => {
        const orb360Frame = $("#360-frame");
        const allProductMedia = JSON.parse(
            $(".product-media-json").text(),
        ).media;
        const filteredProductMedia = allProductMedia.filter(
            (productMediaItem) => {
                if (productMediaItem.type === "image") {
                    if (productMediaItem.src.includes("plp-only")) {
                        return null;
                    }
                }
                return productMediaItem;
            },
        );
        let thumbnailImages = "";

        // Add default height in the featured image slider container
        $(".featured-image").addClass("default-height");

        // Display all Images
        for (let y = 0; y < filteredProductMedia.length; y++) {
            if (filteredProductMedia[y].type === "image") {
                if (y == 0) {
                    thumbnailImages += `<li class="active" ><img class="lazyload" data-src="${filteredProductMedia[y].src}" loading="lazy" data-sizes="auto" width="116.25" height="155.23"></li>`;
                } else {
                    thumbnailImages += `<li><img class="lazyload" data-src="${filteredProductMedia[y].src}" loading="lazy" data-sizes="auto" width="116.25" height="155.23"></li>`;
                }

                const srcset = generateSrcsetForProductImages(
                    filteredProductMedia[y].src,
                );
                const fallbackSrc = buildSizedImageUrl(
                    filteredProductMedia[y].src,
                    1100,
                );
                const isLcpSlide = y === 0;
                const loadingAttrs = isLcpSlide
                    ? 'loading="eager" fetchpriority="high"'
                    : 'loading="lazy"';

                if (y == 1 && orb360Frame && orb360Frame.html() !== undefined) {
                    $(".featured-image").slick(
                        "slickAdd",
                        `<span class="product-image-slide"><div class="g"><div class="t" style="height:80vh">${orb360Frame.html()}</div></div></span>`,
                    );
                }

                $(".featured-image").slick(
                    "slickAdd",
                    `<span class="product-image-slide"><a href="${filteredProductMedia[y].src}" data-fancybox="images"></a><hover-zoomer class="product__thumb-zoom-wrapper" data-zoom="${filteredProductMedia[y].src}"><img class="lazyload" srcset="${srcset}" sizes="${PRODUCT_IMAGE_SIZES}" src="${fallbackSrc}" ${loadingAttrs} width="409" height="551.03"></hover-zoomer></span>`,
                );
            } else if (filteredProductMedia[y].type === "video") {
                if (y == 0) {
                    thumbnailImages += `<li class="active"><video playsinline="true" loop="true" muted="true" autoplay="true"><source src="${filteredProductMedia[y].src}" width="116.25" height="155.23"></video></li>`;
                } else {
                    thumbnailImages += `<li><video playsinline="true" loop="true" muted="true" autoplay="true"><source src="${filteredProductMedia[y].src}" width="116.25" height="155.23"></video></li>`;
                }

                $(".featured-image").slick(
                    "slickAdd",
                    `<span class="product-image-slide"><div><video playsinline="true" loop="true" muted="true" autoplay="true"><source src="${filteredProductMedia[y].src}" width="409" height="551.03"></video></div></span>`,
                );
            }
        }

        $(".thumbnails").html(thumbnailImages);

        if (document.querySelector('[data-grid="true"]')) {
            $(".product-image-grid").zoom({
                on: "click",
                duration: 300,
            });
        }

        $(".product-image-slide a").fancybox({
            padding: 0,
            margin: 0,
            aspectRatio: true,
            fitToView: true,
            autoResize: true,
            infobar: false,
            buttons: ["zoom", "close"],
            helpers: {
                overlay: {
                    css: {
                        "background-image": "none",
                        "background-color": "#000",
                        "box-shadow": "none",
                    },
                },
            },
            wrapCSS: "productPageZoomImageWrap",
            afterLoad: () => {},
        });

        // Image Zoom initialization
        $(".product-image-slide").zoom({
            on: "click",
            duration: 300,
        });
        if ($(window).width() < 1024) {
            // destory zoom mobile
            $(".product-image-slide").trigger("zoom.destroy");
        }
    };

    if ($(".template-product").length > 0) {
        const productForm = document.querySelector(".product-form");
        if (productForm) {
            productForm.addEventListener("submit", (event) => {
                // Use add to cart button as back in stock form trigger when product is out of stock.
                if (event.target.classList.contains("back-in-stock")) {
                    event.preventDefault();
                    event.stopPropagation();

                    document.dispatchEvent(
                        new CustomEvent("back-in-stock:open"),
                    );
                }
            });
        }
    }

    $(".featured-image").slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        fade: true,
        prevArrow: '<i class="fal fa-chevron-left slick-prev"></i>',
        nextArrow: '<i class="fal fa-chevron-right slick-next"></i>',
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    dots: true,
                },
            },
        ],
    });

    $(".thumbnails").on("click", "li", function () {
        $(this).siblings().removeClass("active");
        $(this).addClass("active");
        $(".featured-image").slick("slickGoTo", $(this).index());
    });

    $(".featured-image").on(
        "beforeChange",
        (event, slick, currentSlide, nextSlide) => {
            $(".thumbnails > li").eq(currentSlide).removeClass("active");
            $(".thumbnails > li").eq(nextSlide).addClass("active");
            $(".t").css(
                "height",
                $('.slick-slide[data-slick-index="0"] img').height(),
            );
        },
    );

    $(".featured-image").on("afterChange", () => {
        if (
            $('.slick-slide[data-slick-index="1"]:has(.t)').hasClass(
                "slick-active",
            )
        ) {
            $(".slick-arrow").addClass("active-arrow");
        } else {
            $(".slick-arrow").removeClass("active-arrow");
        }
    });

    $(".thumbnails > li.active").trigger("click");

    $("#tab-description").click(function () {
        $(this).addClass("active");
        $("#tab-shipping").removeClass("active");
        $(".shipping").hide();
        $(".description").show();
    });

    $("#tab-shipping").click(function () {
        $(this).addClass("active");
        $("#tab-description").removeClass("active");
        $(".description").hide();
        $(".shipping").show();
    });

    const notificationCallback = (data) => {
        if (data.status == "OK") {
            $(".bis-form").hide();
            $(".back-in-stock-email-container .bis-message.bis-success").show();
            $(".back-in-stock-email-container .bis-message.bis-error").hide();
            $(".back-in-stock-email-container .bis-message.bis-blank").hide();
        } else {
            $(
                ".back-in-stock-email-container .bis-subscription-email",
            ).addClass("error");
            $(".back-in-stock-email-container .bis-message.bis-error").show();
            $(".back-in-stock-email-container .bis-message.bis-blank").hide();
            $(".back-in-stock-email-container .bis-message.bis-success").hide();
        }
    };

    $("#bisEmailSubmit").on("click", (e) => {
        const theEmail = $(
            ".back-in-stock-email-container .bis-subscription-email",
        ).val();
        const variantId = $('select[name="id"]').val();
        const productId = $('select[name="id"]').attr("data-product-id");
        let extraParam = {};

        if (
            $(
                ".back-in-stock-email-container .bis-subscribe-newsletter:checked",
            ).length > 0
        ) {
            extraParam = {
                accepts_marketing: true,
            };
        }

        if (theEmail.trim() == "") {
            $(
                ".back-in-stock-email-container .bis-subscription-email",
            ).addClass("error");
            $(".back-in-stock-email-container .bis-message.bis-blank").show();
            $(".back-in-stock-email-container .bis-message.bis-error").hide();
            $(".back-in-stock-email-container .bis-message.bis-success").hide();
        } else {
            BIS.create(theEmail, variantId, productId, extraParam).then(
                notificationCallback,
            );
        }

        e.preventDefault();
    });

    $(".back-in-stock-email-container .bis-subscription-email").on(
        "focus",
        (e) => {
            e.target.classList.remove("error");
        },
    );

    // Remove Slider class for default height
    $(document).on("lazyloaded", (e) => {
        const imageElement = $(e.target);
        const featuredImageContainer = $(".featured-image");
        if (imageElement.parent().hasClass("slick-slide")) {
            if (featuredImageContainer.hasClass("default-height")) {
                featuredImageContainer.removeClass("default-height");
            }
        }
    });

    // Trigger the slideshow images to render on load
    renderSlideshowImages();
});

document.addEventListener(
    "click",
    (event) => {
        if (event.target.matches(".show-social-share-buttons")) {
            if (window.innerWidth > 767) {
                const social_element = document.getElementById(
                    "social-share-wrapper",
                );
                social_element.classList.remove("hidden");
            } else {
                document
                    .querySelector(
                        "content-drawer[data-drawer_id=social-share]",
                    )
                    .open();
            }
        } else if (event.target.matches(".size-chart-toggle")) {
            const sizeDrawer = document.querySelector(".sizeDrawer");
            if (sizeDrawer) {
                openDrawer(sizeDrawer);
                return;
            }
        } else if (event.target.matches(".copy-clipboard-product-url")) {
            const copy_text = document.getElementById("copy-product-url");
            navigator.clipboard.writeText(copy_text.innerHTML);
        } else {
            // If the clicked element doesn't have the right selector, bail
            return;
        }
    },
    false,
);

document.addEventListener("DOMContentLoaded", () => {
    // run only on product page, check by element
    const product_page_element = document.getElementById(
        "shopify-section-product",
    );
    if (
        typeof product_page_element != "undefined" &&
        product_page_element != null
    ) {
        // confirmed product page, get current product's handle and store in cookie for recently viewed section
        const product_handle = $('select[name="id"]').attr(
            "data-product-handle",
        );
        let recently_viewed_products = getCookie("recently_viewed_products");
        if (
            recently_viewed_products != "" &&
            recently_viewed_products !== null
        ) {
            // check if current handle is already stored in cookie, else append product handle to existing set of handles from cookie
            if (recently_viewed_products.indexOf(product_handle) <= -1) {
                recently_viewed_products = `${recently_viewed_products},${product_handle}`;
                setCookie(
                    "recently_viewed_products",
                    recently_viewed_products,
                    14,
                );
            }
        } else {
            setCookie("recently_viewed_products", product_handle, 14);
        }
    }
});

$(window).on("resize", () => {
    $(".t").css("height", $('.slick-slide[data-slick-index="0"] img').height());
});
